import React from 'react';
import { Ellipsis } from '@gravity-ui/icons';
import { useMeasure } from 'react-use';
import { cn } from '../classname';
import { logger } from '../logger';
import { useRenderTime } from '../react-utils/hooks';
import { Toolbar } from './Toolbar';
import { ToolbarListButton } from './ToolbarListButton';
import { shrinkToolbarData } from './flexible';
import { ToolbarDataType } from './types';
import './FlexToolbar.css';
const b = cn('flex-toolbar');
export function FlexToolbar(props) {
    useRenderTime((time) => {
        logger.metrics({
            component: 'toolbar',
            event: 'render',
            duration: time,
        });
    });
    const { data, className, hiddenActions } = props;
    const [ref, { width }] = useMeasure();
    const { data: items, dots } = React.useMemo(() => {
        const toolbarButtonIds = data.reduce((a, toolbarGroup) => {
            return [
                ...a,
                ...toolbarGroup
                    .map((toolbarButton) => {
                    if (toolbarButton.type === ToolbarDataType.ListButton) {
                        return toolbarButton.data.map((v) => v.id);
                    }
                    return toolbarButton.id;
                })
                    .flat(),
            ];
        }, []);
        // Finding only actions tha are not present in the main toolbar config
        const filteredHiddenAction = hiddenActions === null || hiddenActions === void 0 ? void 0 : hiddenActions.filter((a) => !toolbarButtonIds.includes(a.id));
        return shrinkToolbarData({
            data,
            availableWidth: width,
            hiddenActions: filteredHiddenAction,
        });
    }, [data, width, hiddenActions]);
    return (React.createElement("div", { ref: ref, className: b(null, [className]) },
        React.createElement("div", { className: b('container') },
            React.createElement(Toolbar, Object.assign({}, props, { data: items, className: b('bar') })),
            (dots === null || dots === void 0 ? void 0 : dots.length) && (React.createElement(ToolbarListButton, { data: dots, icon: { data: Ellipsis }, title: props.dotsTitle, editor: props.editor, focus: props.focus, onClick: props.onClick, className: b('dots'), alwaysActive: true })))));
}
